import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import Loading from 'Components/Progress/Loading';
import registry from 'Src/skeletons/registry';

// The first page group (in config/chunk-groups.js order, as server.js matches them) with a path matching the route
const findSkeleton = pathname => registry.find(({ paths }) => (
  paths.some(path => matchPath(pathname, { path, exact: true }))
));

/**
 * The skeleton of the page being loaded, the same one server.js shows on first load, or the spinner for pages
 * without one.
 */
export default function RouteSkeleton() {
  const { pathname } = useLocation();
  const match = findSkeleton(pathname);

  if (!match) {
    return <Loading />;
  }

  const { Skeleton } = match;
  return <Skeleton />;
}
